var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue_body_min_height",attrs:{"id":"train_coach_outer"}},[(_vm.currentBanner != null)?_c('div',[_c('div',[_c('img',{staticStyle:{"width":"100%","height":"auto"},attrs:{"src":_vm.currentBanner.url}})])]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-212767b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CoachPage.vue
// module id = null
// module chunks = 